import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { csvFileSchemaObject } from '../fieldSchema';
import _, { forEach, set } from 'lodash';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import TextField from "@material-ui/core/TextField";
import * as XLSX from 'xlsx';
import moment from 'moment';

const screenCode = 'CSVFILEDOWNLOAD'

export function CSVFile(props) {
    const [title, setTitle] = useState("CSV Fle Download");
    const [groups, setGroups] = useState([]);
    const [estate, setEstate] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [csvDetails, setCsvDetails] = useState({
        groupID: '0',
        estateID: '0',
        collectionPointCategoryID: '0',
        searchDate: '',
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Error",
        disciption: "No data found."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const currentProps = {};
    const schema = Joi.object(csvFileSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstateForDropdown()
        )
    }, [csvDetails.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointCategoryForDropDown()
        )
    }, [csvDetails.estateID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCSVFILEDOWNLOAD');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITFIELD');

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setCsvDetails({
            ...csvDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getEstateForDropdown() {
        const estate = await services.GetAllEstatesByGroupID(csvDetails.groupID);
        setEstate(estate);

    }

    async function getCollectionPointCategoryForDropDown() {
        const collectionPoint = await services.getAllDivisionsByEstateID(csvDetails.estateID);
        setCollectionPoint(collectionPoint);
    }

    function handleGroupDropdown(target) {
        validateInputs(target);

        setCsvDetails({
            ...csvDetails,
            groupID: target.value,
            estateID: '0',
            collectionPointCategoryID: '0',
            searchDate: "",
        });
        setCsvData([]);
        modalDismissHandler();
    }

    function handleOperationEntityDropdown(target) {
        validateInputs(target);

        setCsvDetails({
            ...csvDetails,
            estateID: target.value,
            collectionPointCategoryID: '0',
            searchDate: "",
        });
        setCsvData([]);
        modalDismissHandler();
    }

    function handleCollectionPointDropdown(target) {
        validateInputs(target);

        setCsvDetails({
            ...csvDetails,
            collectionPointCategoryID: target.value,
            searchDate: "",
        });
        setCsvData([]);
        modalDismissHandler();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, csvFileSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }

    async function handleSearch(e) {
        if (e !== undefined) {
            const errorMessages = validate(schema, csvDetails);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getCSVData(csvDetails);
        if (response.length == 0) {
            setMessageModel({ ...messageModel, type: "Error", disciption: "No data found.", hidden: false });
        } else {
            setMessageModel({ ...messageModel, type: "Success", disciption: `${response.length} Data found. Can download CSV file`, hidden: false });
            setCsvData(response);
        }
    }

    async function createDataForExcel(array) {
        var res = [];

        if (array != null) {
            array.forEach(x => {
                var row = [
                    x.number.padStart(5, '0') + "_0",
                    x.registrationNumber,
                    moment(x.cardReadTime).format('M/DD/YYYY'),
                    x.grossAmount,
                    x.emp1,
                    x.emp2,
                    x.netAmount,
                    x.emp4,
                    x.emp5,
                    x.emp6,
                    x.emp7,
                    x.emp8,
                    x.emp9,
                    x.routeCode,
                    x.emp10,
                ];

                res.push(row);
            });
        }

        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(csvData);
        
        const ws = XLSX.utils.aoa_to_sheet(file);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Supplier');

        const excelBuffer = XLSX.write(wb, { bookType: 'csv', bookSST: false, type: 'array' });

        const collectionPointName = collectionPoint[csvData[0].routeCode];
        
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        const fileName = `CSV_File - ${collectionPointName} - ${csvDetails.searchDate}.csv`;

        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setCsvDetails({
            ...csvDetails,
            searchDate: target.value
        });
        setCsvData([]);
        modalDismissHandler();
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setCsvDetails({
            ...csvDetails,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            estateID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointCategoryID: '0',
            searchDate: '',
        });
        setCsvData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                />
                            </div>
                            <hr />

                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={csvDetails.groupID}
                                            onChange={(e) => handleGroupDropdown(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="estateID"
                                            value={csvDetails.estateID}
                                            onChange={(e) => handleOperationEntityDropdown(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estate)}
                                        </Select>
                                        {errors["estateID"] && <FormHelperText error>{errors["estateID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointCategoryID">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointCategoryID"
                                            id="collectionPointCategoryID"
                                            name="collectionPointCategoryID"
                                            value={csvDetails.collectionPointCategoryID}
                                            onChange={(e) => handleCollectionPointDropdown(e.target)}>
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointCategoryID"] && <FormHelperText error>{errors["collectionPointCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Search Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            value={csvDetails.searchDate}
                                            onInput={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} hidden={csvData.length == 0}>
                                    <div style={{ border: '2px solid green', borderRadius: '16px', marginTop: '3rem', marginLeft: '5rem', marginRight: '5rem' }}>
                                        <div style={{ width: '75%', maxWidth: '100%' }}>
                                            <div style={{ marginLeft: '8.5rem' }}>
                                                <h2><b>Download CSV File</b></h2>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: '3rem' }}>
                                            <div style={{ flex: '1 1 50%', maxWidth: '100%' }}>
                                                <div style={{ marginLeft: '6rem', marginTop: '0.7rem' }}>
                                                    <h6></h6>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                                                    <input
                                                        type="button"
                                                        className="btn btn-primary"
                                                        value="CSV File"
                                                        onClick={createFile}
                                                        disabled={csvData.length == 0}
                                                        hidden={csvData.length == 0}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}